'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIList from 'UIComponents/list/UIList';
import UIBadge from 'UIComponents/badge/UIBadge';
import HublDocsPanel from 'DesignComponents/hublDocs/HublDocsPanel';
import { usageTrackerActions } from 'usage-tracker-redux';
import { getExtraJsonForAction } from '../utils/usageTracker/eventUtils';
const {
  track
} = usageTrackerActions;

const statusBarI18nKey = key => `DesignEditorsUI.statusBar.header.reference.${key}`;

const LINKS = {
  localdev: 'https://designers.hubspot.com/docs/developer-reference/local-development-cms-cli',
  designmanager: 'https://designers.hubspot.com/docs/developer-reference/design-manager',
  blocks: 'https://designers.hubspot.com/docs/building-blocks'
};
const menuItemWrapper = 'status-bar-menu-item';
const buttonClass = 'p-x-0';
const mapDispatchToProps = {
  track
};

class StatusBarReference extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      openHublDocs: false,
      isOpen: false
    };

    this.trackLink = link => {
      this.props.track('welcomePageInteraction', getExtraJsonForAction('designers-link-clicked', {
        link
      }));
    };

    this.toggleOpen = () => {
      const isOpen = !this.state.isOpen;
      this.setState({
        isOpen
      });
    };

    this.onOpenChange = ({
      target: {
        value: isOpen
      }
    }) => {
      this.setState({
        isOpen
      });
    };

    this.toggleHublDocPanel = () => {
      this.setState({
        openHublDocs: !this.state.openHublDocs
      });
    };
  }

  renderHublPanel() {
    if (!this.state.openHublDocs) return null;
    return /*#__PURE__*/_jsx(HublDocsPanel, {
      toggleHublDocPanel: this.toggleHublDocPanel,
      isOpen: this.state.openHublDocs
    });
  }

  renderLink(key, extra = null) {
    const href = LINKS[key];
    return /*#__PURE__*/_jsxs("div", {
      className: "flex-no-wrap align-center",
      children: [/*#__PURE__*/_jsx(UIButton, {
        external: true,
        href: href,
        use: "transparent",
        className: buttonClass,
        onClick: () => this.trackLink(href),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey(`links.${key}`)
        })
      }, key), extra]
    });
  }

  renderMenuSeparator() {
    return /*#__PURE__*/_jsx("div", {
      className: "reference-menu-separator"
    });
  }

  renderMenuHeader(node) {
    return /*#__PURE__*/_jsx("div", {
      className: "reference-menu-header",
      children: node
    });
  }

  renderMenuItem(node) {
    return /*#__PURE__*/_jsx("div", {
      className: menuItemWrapper,
      children: node
    });
  }

  renderMenu() {
    return /*#__PURE__*/_jsxs(UIList, {
      onClick: this.toggleOpen,
      children: [this.renderMenuHeader( /*#__PURE__*/_jsx(FormattedMessage, {
        message: statusBarI18nKey('devdocs')
      })), this.renderMenuItem(this.renderLink('designmanager')), this.renderMenuItem(this.renderLink('blocks')), this.renderMenuItem(this.renderLink('localdev', /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        children: "New"
      }))), this.renderMenuSeparator(), this.renderMenuItem( /*#__PURE__*/_jsx(UIButton, {
        use: "transparent",
        className: buttonClass,
        onClick: this.toggleHublDocPanel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('links.hubl')
        })
      })), this.renderMenuSeparator()]
    });
  }

  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UIPopover, {
        className: "status-bar-popover",
        open: this.state.isOpen,
        content: this.renderMenu(),
        placement: "top left",
        closeOnOutsideClick: true,
        onOpenChange: this.onOpenChange,
        children: /*#__PURE__*/_jsxs(UIButton, {
          className: "status-bar-header-button",
          size: "extra-small",
          use: "transparent",
          onClick: this.toggleOpen,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "status-bar-popover--icon",
            name: "book"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: statusBarI18nKey('button.label')
          })]
        })
      }), this.renderHublPanel()]
    });
  }

}

StatusBarReference.propTypes = {
  track: PropTypes.func.isRequired
};
StatusBarReference.contextType = TourContext;
export default connect(null, mapDispatchToProps)(StatusBarReference);